<div *ngIf="ready$ | async" class="h-full flex flex-col">
  <div class="flex justify-between m-3">
    <gs-generic-search [searchComponents]="searchComponentConfig" [visible]="true" (valueChange)="search($event)"
      [searchOnInit]="true" [showRefreshButton]="true" (onInitialized)="onGenericSearchInitialized($event)" />
    <div class="flex my-auto gap-1">
      <dx-button icon="format_list_bulleted" (onClick)="setView('po')"
        [type]="currentView === 'po' ? 'success' : 'normal'" />
      <dx-button icon="account_tree" (onClick)="setView('operation')"
        [type]="currentView === 'operation' ? 'success' : 'normal'" />
    </div>
    <div class="flex gap-1">
      <dx-button class="my-auto" text="today" (onClick)="setToday()" />
      <dx-select-box [items]="viewPresets" displayExpr="name" valueExpr="id" [(value)]="schedulerViewPreset" />
    </div>
  </div>
  <div class="flex-1">
    <div #schedulerContainer [style.display]="(bryntumAvailable === true
                && workCenters.length > 0
                && searchComponent.form?.value.startDate
                && searchComponent.form?.value.endDate) ? 'block' : 'none'">
    </div>
    <div *ngIf="bryntumAvailable === false" class="flex items-center justify-center h-full">
      <p>Bryntum Scheduler está deshabilitado. Para habilitarlo, configura enableScheduler: true en environment.ts</p>
    </div>
  </div>
  <!-- només s'hauria de mostrar si hi ha un detall-->
  <div @slideInOut *ngIf="selectedProductionOrder" class="bg-white shadow"
    [ngClass]="showDetailFullScreen ? 'h-full' : 'h-1/3'">
    <!-- <app-gantt-detail
      [(productionOrder)]="selectedProductionOrder"
      [startDate]="searchComponent.form!.value.startDate"
      [endDate]="searchComponent.form!.value.endDate"
      (fullscreenChange)="showDetailFullScreen = $event"
    /> -->
    <app-planner-detail [(productionOrder)]="selectedProductionOrder"
      [startDate]="searchComponent.form!.value.startDate" [endDate]="searchComponent.form!.value.endDate"
      [operationId]="currentView === 'operation' ? selectedOperationId : undefined"
      (showFullScreen)="showDetailFullScreen = $event" />
  </div>
</div>